import moment from 'moment';
import NumberFormatter from './numberformatter';

let dateConfiguration = null;
const Formatter = {};

Formatter.setConfiguration = function (dateConf, numberConfiguration) {
  NumberFormatter.setConfiguration(numberConfiguration);
  dateConfiguration = dateConf;
};

Formatter.formatNumber = function (value, currency) {
  return NumberFormatter.format(value, currency);
};

Formatter.formatOdd = function (value) {
  return NumberFormatter.formatOdd(value);
};

Formatter.formatPercent = function (value) {
  if (value < 0 || value > 100) {
    throw new Error(`Invalid percent value "${value}". Value must be between 0 and 100`);
  }
  return `${NumberFormatter.formatPercent(value)}%`;
};

Formatter.formatNumber = function (value, currency, abbreviate = false, trimDecimalPartWhenPossible = false) {
  return NumberFormatter.format(value, currency, abbreviate, undefined, trimDecimalPartWhenPossible);
};

Formatter.formatCount = function (value) {
  return NumberFormatter.format(value, '', false, 0);
};

Formatter.formatOrdinal = function (value) {
  return NumberFormatter.ordinal(value);
};

Formatter.formatDate = function (date, format) {
  let f = format;

  // On remplace le format par un format de la config si c'est un alias
  if (dateConfiguration) {
    if (dateConfiguration.patterns && dateConfiguration.patterns[format]) {
      f = dateConfiguration.patterns[format];
    }
  }
  return moment.unix(date).format(f);
};

export default Formatter;
